export const BUDGET_ORGANIZATIONS = Object.freeze(["ETPL", "EPPL", "ESSPL", "EEPL"]);

export const BUDGET_ORGANIZATION_LABELS = Object.freeze({
  ETPL: "ETPL",
  EPPL: "EPPL",
  ESSPL: "ESSPL",
  EEPL: "EEPL",
});

export function normalizeOrganization(raw) {
  const s = String(raw || "").trim().toUpperCase();
  return BUDGET_ORGANIZATIONS.includes(s) ? s : "";
}
